import { UpdatePasswordForm } from '@/components/auth/UpdatePasswordForm';

export function UpdatePassword() {
  return (
    <div className="flex items-center justify-center min-h-[70vh] px-4">
      <UpdatePasswordForm />
    </div>
  );
}